module.exports = __webpack_public_path__ + "img/21.91a075e7.jpg";